module.exports = "/static-assets/_next/static/images/hero-d43507d7ec4b568617561b88eba8e537.jpg";